import { render, staticRenderFns } from "./A-Chamber.vue?vue&type=template&id=193cf8a5&scoped=true&"
import script from "./A-Chamber.vue?vue&type=script&lang=js&"
export * from "./A-Chamber.vue?vue&type=script&lang=js&"
import style0 from "./A-Chamber.vue?vue&type=style&index=0&id=193cf8a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193cf8a5",
  null
  
)

export default component.exports